import { twMerge } from 'tailwind-merge';

import { useRegionStore } from '@packages/stores';
import { getDurationOfDatesInDays } from '@packages/utils';

import { Text } from '@elements/text';
import { i18n } from '@i18n';

type DaysOfTravelProps = {
  startDate: string | undefined;
  endDate: string | undefined;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * Component to display number of travel days based on start and end dates
 */
export const DaysOfTravel = ({ startDate, endDate, className, ...rest }: DaysOfTravelProps) => {
  const country = useRegionStore(state => state.region?.country);
  const days =
    startDate && !endDate
      ? 1
      : startDate && endDate && getDurationOfDatesInDays(startDate, endDate, country);

  return (
    <div {...rest} className={twMerge('flex flex-col items-center p-3', className)}>
      <Text variant="subHeading-14/r">{i18n.t('travelDates.dateSelected.days')}</Text>
      <Text variant="subHeading-14/sb">{days ?? '-'}</Text>
    </div>
  );
};
